import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { HttpClient, HttpParams } from '@angular/common/http';
import { OcorrenciaLogResp } from '../models/ocorrencia-log-resp';

@Injectable({
  providedIn: 'root'
})
export class OcorrenciaLogRespService {

  constructor(private http: HttpClient) { }

  consultarPorIdOcorrencia(idOcorrencia: number) {
    return this.http.get<any>(globals.apiUrl + '/api/OcorrenciaLogResp/BuscarPorIdOcorrencia',
      { params: new HttpParams().set('idOcorrencia', idOcorrencia.toString()) });
  }
}
